<template>
  <div class="form__fieldset">
    <h3 class="form__title">{{ in18['attribute_payment_method'] }}</h3>
    <div class="row">
      <div v-for="paymentMethod in paymentMethods" class="col-md-6  mb-4">
        <div :class="{ 'disabled': inProgress }" class="radio-btn">
          <input
              :id="paymentMethod.code"
              v-model="selectedPaymentMethod"
              :value="paymentMethod"
              class="radio-btn__input"
              name="payment-method"
              type="radio"
              @change="selectPaymentMethod()"
          >
          <label :for="paymentMethod.code" class="radio-btn__label">
            <picture>
              <source :srcset="paymentMethod.image.webp" type="image/webp">
              <img :alt="paymentMethod.title" :src="paymentMethod.image.source" class="radio-btn__icon">
            </picture>
            <div class="radio-btn__title">{{ paymentMethod.title }}</div>
            <div class="radio-btn__text">{{ paymentMethod.description }}</div>
          </label>
        </div>
      </div>
      <validation-error :errors="errors['payment_method']"/>
    </div>
  </div>
</template>

<script>

import ValidationError from '../../features/ValidationError.vue';

export default {

  name: "CheckoutPayment",

  components: {
    'validation-error': ValidationError
  },

  props: {
    in18:       {
      type: Object,
    },
    errors:     {
      type: Object,
    },
    cart:       {
      type: Object,
    },
    inProgress: {
      type: Boolean,
    },
    selectedShippingMethod: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      paymentMethods:        [],
      selectedPaymentMethod: null,
    }
  },

  emits: [
    'update-payment-method',
    'update-in-progress',
  ],


  created() {
    this.getPaymentMethods();
  },

    watch: {
        selectedShippingMethod: {
            handler: function () {
                this.getPaymentMethods();
            },
            deep: true,
        }
    },

  methods: {

    getPaymentMethods() {
      axios.get(`/api/payment?shipping_method_id=${this.selectedShippingMethod.id}`)
          .then((response) => {
            this.paymentMethods = response.data.paymentMethods;
          })
          .finally(() => {
              this.selectedPaymentMethod = this.cart.payment_method ? this.cart.payment_method : null;
              this.$emit('update-in-progress', false);
          })
    },

    selectPaymentMethod() {

      this.$emit('update-in-progress', true);

      return axios.post('/api/cart/payment/' + this.selectedPaymentMethod.id)
          .then((response) => {
            this.$emit('update-payment-method', this.selectedPaymentMethod);
            ga_add_payment_info_event(response.data.cart);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          });
    },
  },
};

</script>
